const Division = [
    {
        "bIndex": 0,
        "eIndex": 20,
        "color": "#3FA9F5",
        "cx": 150,
        "text": "Domain problem",
        "maxR": 30,
        "blankD": [7, 12, 13, 15, 17, 18, 19, 20]
    },
    {
        "bIndex": 21,
        "eIndex": 43,
        "color": "#22B573",
        "cx": 550,
        "text": "Visualization",
        "maxR": 30,
        "blankD": [29, 34, 43]
    },
    {
        "bIndex": 44,
        "eIndex": 68,
        "color": "#FF931E",
        "cx": 950,
        "text": "Computation",
        "maxR": 30,
        "blankD": [50, 57, 64, 65, 66, 67, 68]
    },
    {
        "bIndex": 69,
        "eIndex": 73,
        "color": "#FF7BAC",
        "cx": 1350,
        "text": "System",
        "maxR": 30,
        "blankD": []
    }
]

export {Division}